export enum StaffViewType {
  TailNumber = 1,
  AirportCode = 2
}
